import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {styled} from '@mui/system';

import {concatUrl} from '../../helpers/url';
import {postCall} from '../../helpers/request';
import GlobalContext from '../../helpers/context';


const StyledBreadCrumb = styled('div')(({ theme }) =>({
    paddingLeft: theme.custom.paper.side_space,
    paddingRight: theme.custom.paper.side_space,
    paddingTop: 5,
    paddingBottom: 5,
    borderBottom: '1px solid #efefef'
}));

const StyledLink = styled(Link)({
    textDecoration: 'none',
    '&:hover':{
        textDecoration: 'underline'
    }
});


class BreadCrumbs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            breadcrumbs: []
        };

        this.is_mounted = false;
         this.breadcrumbs_url = concatUrl(window.ROOT_URL, 'api', 'breadcrumbs');
    }

    componentDidMount(){
        this.is_mounted = true;
        this.getBreadCrumbs();
    }

    componentWillUnmount(){
        this.is_mounted = false;
    }

    componentDidUpdate(prevProps, prevState, _){
        if(prevState.breadcrumbs === [] ||
            'pathName' in this.props && 'params' in this.props &&
            (this.props.pathName !== prevProps.pathName ||
                this.props.params !== prevProps.params)){
            this.getBreadCrumbs();
        }
    }


    // +++ get breadcrumbs information +++++++++++++++++++++++++++++++++++++++++++++++

    getBreadCrumbsFailed = () => {
        if(!this.is_mounted) {
            // skip updating component if not mounted to avoid.
            return;
        }

        this.context.displayGlobalError('Backend service failure: Could not receive breadcrumbs data.');
    };

    getBreadCrumbsDone = (data, callback_failure) => {
        if(!this.is_mounted) {
            // skip updating component if not mounted to avoid.
            return;
        }

        if(data){
            this.setState({
                breadcrumbs: data
            });
        }else{
            callback_failure();
        }
    };

    getBreadCrumbs = () => {
        let data = {
            pathname: this.props.pathName,
            url_params: this.props.params
        };
        postCall(this.breadcrumbs_url, data, this.getBreadCrumbsDone, this.getBreadCrumbsFailed);
    };

    breadcrumb_item = (item, last_item) => {
        if(!last_item){
            return <StyledLink key={item.label} href={item.url} data-bt="navigation_item">{item.label}</StyledLink>;
        }
        return <Typography key={item.label} color="textPrimary">{item.label}</Typography>;
    };

    render() {
        return (
            <StyledBreadCrumb data-bt="breadcrumb_navigation">
                <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" data-bt="navigation_list">
                {this.state.breadcrumbs.map((breadcrumb, index) =>
                    this.breadcrumb_item(breadcrumb, index === this.state.breadcrumbs.length-1)
                )}
                </Breadcrumbs>
            </StyledBreadCrumb>
        );
    }

}


BreadCrumbs.contextType = GlobalContext;

BreadCrumbs.propTypes = {
    pathName: PropTypes.string,
    params: PropTypes.object
};

export default BreadCrumbs;
